import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useMemo } from 'react';
import { FileIcon } from '@/components/SvgIcon/index';
import { Modal } from 'antd';
import classNames from 'classnames';
import { useVideoPoster } from '../hooks';
import { getMediaLink } from '@/services/chat';
import { fullPath } from '@/utils';
import aegis from '@/utils/aegis';
const FileContent = (param)=>{
    let { info } = param;
    const { message, is_dynamic_load, id } = info;
    const videoRef = useRef(null);
    const [open, setOpen] = useState(false);
    /** 文件地址状态 */ const [fileUrl, setFileUrl] = useState(is_dynamic_load ? null : message);
    const [posterKey, setPosterKey] = useState(0);
    /** 文件类型/是否视频 */ const isVideo = useMemo(()=>{
        const lower = (fileUrl || message || '').toLowerCase();
        return /\.(mp4|avi|mov|mkv|webm)(\?|$)/i.test(lower) || [
            'mime_type=video',
            'tiktokcdn.com',
            'lazvideo.lazcdn.com'
        ].some((k)=>lower.includes(k));
    }, [
        fileUrl,
        message
    ]);
    /** 视频封面 */ const poster = useVideoPoster(fileUrl || message, posterKey);
    /** 点击播放时，动态请求文件 */ const handlePlay = async ()=>{
        if (is_dynamic_load && id && !fileUrl) {
            try {
                const res = await getMediaLink({
                    jk_chat_log_id: id
                });
                if (res === null || res === void 0 ? void 0 : res.url) setFileUrl(res.url);
            } catch (error) {
                console.error('获取动态文件链接失败:', error);
                aegis.error({
                    msg: `VIDEO_FETCH_ERROR\n\njk_chat_log_id: ${id}`
                });
            }
        }
        /** 如果封面是默认封面，也强制刷新触发封面更新最新的 */ if (isVideo && (!poster || poster.includes('video-cover.png'))) {
            setPosterKey((prev)=>prev + 1);
        }
        setOpen(true);
    };
    /** 弹出层控制视频播放 */ const handleModalClose = ()=>{
        var _videoRef_current;
        setOpen(false);
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.pause();
    };
    /** 文件名格式化 */ const formatFileName = (fileName)=>{
        var _fileName_split;
        const str = (_fileName_split = fileName.split('/')) === null || _fileName_split === void 0 ? void 0 : _fileName_split.pop();
        if (!str) return '';
        return str.length > 40 ? str.slice(-40) : str;
    };
    useEffect(()=>setFileUrl(is_dynamic_load ? null : message), [
        is_dynamic_load,
        message
    ]);
    if (isVideo) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "relative w-[180px] h-[100px] rounded-[8px] overflow-hidden bg-black cursor-pointer group",
                    onClick: handlePlay,
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: poster || fullPath('video-cover.png'),
                            alt: "video cover",
                            className: "w-full h-full object-cover transition-transform group-hover:scale-105 duration-300"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "absolute inset-0 flex items-center justify-center bg-black/40 hover:bg-black/50",
                            children: /*#__PURE__*/ _jsx("svg", {
                                width: "38",
                                height: "38",
                                viewBox: "0 0 1024 1024",
                                fill: "#fff",
                                children: /*#__PURE__*/ _jsx("path", {
                                    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM416 704V320l320 192-320 192z"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Modal, {
                    open: open,
                    onCancel: handleModalClose,
                    footer: null,
                    width: '90%',
                    centered: true,
                    closeIcon: null,
                    styles: {
                        content: {
                            padding: 0,
                            background: '#000',
                            borderRadius: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative'
                        }
                    },
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            onClick: handleModalClose,
                            style: {
                                position: 'absolute',
                                top: 16,
                                right: 16,
                                zIndex: 10,
                                background: '#fff',
                                color: '#000',
                                borderRadius: '50%',
                                width: 40,
                                height: 40,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: 'none',
                                cursor: 'pointer'
                            },
                            children: "✕"
                        }),
                        /*#__PURE__*/ _jsx("video", {
                            ref: videoRef,
                            src: fileUrl || '',
                            className: "w-full h-[80vh] object-contain",
                            controls: true,
                            autoPlay: true,
                            onError: (err)=>{
                                aegis.error({
                                    msg: `VIDEO_PLAY_ERROR\nURL: ${fileUrl}}`
                                });
                            }
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("a", {
        href: fileUrl || message,
        target: "_blank",
        rel: "noopener noreferrer",
        className: classNames('flex items-center gap-[8px]'),
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "flex",
                children: FileIcon
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "text-[#363636] break-all",
                children: formatFileName(fileUrl || message)
            })
        ]
    });
};
export default FileContent;
